export function getCookie(key: string) {
  const value = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`)
  return value ? value[2] : null
}
